import type { NodeId, InputId } from 'web';
import type { FlowGraph } from '../FlowGraph';

export interface ResolvedImage {
  url: string;
  width: number;
  height: number;
}

export class KlingElementView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
  ) {}

  getInputNodeId(inputId: InputId) {
    return this.graph.getNodeInput(this.id, inputId);
  }

  renderImageInput(inputId: InputId): ResolvedImage | undefined {
    const input = this.graph.getNodeInput(this.id, inputId);
    if (!input) return undefined;
    const rendered = this.graph.wasm.call((wasm) => wasm.exportNodeRender(input.nodeId, input.outputId));
    return rendered ? { url: rendered.data, width: rendered.width, height: rendered.height } : undefined;
  }
}
